import React, { Component } from 'react';
import { Table, } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';
// import allStocks from '../../data/stock_us_filtered_sorted.json';

class StockSplitCalender extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stockSplitCalenderList: [],
        };
    }

    custom_sort(a, b) {
		return new Date(a.date).getTime() - new Date(b.date).getTime();
	}

    componentDidMount() {
        ApiService.getStockSplitCalender()
            .then(result => {
                console.log('Stock Split Calender', result);
                let filteredData = [];
                let length = 5;
                if (result.length > 0) {

                   //Remove other country ticker
                //    let tmpFiltered = [];
                //    for (var i=0; i<result.length; i++){
                //        for (var j=0; j<allStocks.length; j++){
                //            if (result[i].symbol === allStocks[j].symbol){
                //                tmpFiltered.push(result[i]);
                //                break;
                //            }
                //        }
                //    }
                //    result = tmpFiltered;

                    result.sort(this.custom_sort);
                    filteredData = result;
                    // var helper = {};
                    // filteredData = result.reduce(function (r, o) {
                    //     var key = o.date + '-' + o.time;

                    //     if (!helper[key]) {
                    //         helper[key] = Object.assign({}, o); // create a copy of o
                    //         r.push(helper[key]);
                    //     } else {
                    //         helper[key].symbol += ' ' + o.symbol;
                    //     }

                    //     return r;
                    // }, []);                   
                    length = filteredData.length < length ? filteredData.length : length;
                    filteredData = filteredData.slice(0, length);
                    console.log('Stock Split Calender filter', result, filteredData);
                }
                this.setState({ stockSplitCalenderList: filteredData });
            })
            .catch((error) => {
                console.log(error);
            });

    }

    rederSymbolRow(symbol) {
        if (symbol !== undefined) {
            let url = '/chart/' + symbol;
            return (
                <><Link to={url}>{symbol}</Link>{' '}{' '}{' '}</>
            )
        }
    }

    renderRow(listValue) {
        if (listValue !== undefined && listValue.symbol !== undefined) {
            let allSymbols = listValue.symbol.split(' ');
            allSymbols = allSymbols.slice(0, 30);
            return (
                <tr key={listValue.symbol + listValue.date + Math.random()}>
                    <td>{listValue.date}</td>
                    <td style={{ overflowWrap: 'break-word', textAlign: 'left' }}>{allSymbols.map(this.rederSymbolRow.bind(this))}</td>
                </tr>
            )
        }
    }

    render() {
        let tableRow;
        if (this.state.stockSplitCalenderList === null || this.state.stockSplitCalenderList.length <= 0) {
            tableRow = <tr><td></td><td>No Data</td></tr>
        } else {
            tableRow = this.state.stockSplitCalenderList.map(this.renderRow.bind(this));
        }
        console.log('stockSplitCalenderList', this.state.stockSplitCalenderList.length);
        return (
            // <Card border="secondary" style={{ height: '250px' }}>
            //     <Card.Header>Stock Split Calender</Card.Header>
            <Table striped bordered hover size="xs" style={{ fontSize: "10px" }}>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Stock Split Ticker</th>
                    </tr>
                </thead>
                <tbody>
                    {tableRow}
                </tbody>
            </Table>
            // </Card>
        );
    }
}

export default StockSplitCalender;
